import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';

@Component({
  template: `zzz`,
  styles: [
    ``,
  ],
})
export class LogoutViewComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
    this.authService.logout();
    this.router.navigateByUrl('/auth/login');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/views/logoutView/logoutView.component.ts